import { cloneElement } from 'react';
import cn from 'classnames';
import parseClassnames from "../../../helpers/parseClassnames";
import { jsx as _jsx } from "react/jsx-runtime";
var MainTitle = function MainTitle(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'm' : _ref$type,
    mainTitle = _ref.mainTitle,
    isDark = _ref.isDark,
    hasMoreElements = _ref.hasMoreElements;
  var classes = hasMoreElements ? cn('block text-center mb-16', {
    'sm:mb-24': type === 'm' || type === 'full'
  }) : 'block text-center';
  if (typeof mainTitle === 'string') {
    return /*#__PURE__*/_jsx("h3", {
      className: cn(classes, type === 's' ? 'font-h3' : 'font-h2', isDark ? 'text-white' : 'text-base-main'),
      children: mainTitle
    });
  }
  var mainTitleElement = mainTitle;
  return /*#__PURE__*/cloneElement(mainTitleElement, {
    className: parseClassnames(mainTitleElement.props.className || '', classes)
  });
};
export default MainTitle;